/* ==========================================================================
   Peru Balloons · Rediseño — Colección (PLP) · pb-plp.js
   Filtros por facetas (con conteos), orden y filtros activos en la URL, todo en el navegador: las colecciones son
   chicas y así filtrar es instantáneo. Las facetas salen de las etiquetas y el precio de cada producto (Liquid).
   ========================================================================== */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  const grid = $('[data-grid]');
  if (!grid) return;
  const cards = $$('.plp-card', grid);
  const form = $('[data-filters]');
  const inputs = $$('input', form);
  const groups = [...new Set(inputs.map((i) => i.name))];
  const sortSelect = $('[data-sort]');
  const countEl = $('[data-result-count]');
  const applyBtn = $('[data-apply-label]');
  const badge = $('[data-filter-count]');
  const chipsEl = $('[data-active-filters]');
  const emptyEl = $('[data-empty]');
  let interactive = false; // las tarjetas solo se animan al filtrar u ordenar, no al cargar

  const plural = (n) => `${n} ${n === 1 ? 'producto' : 'productos'}`;
  const valuesOf = (card, group) => (card.dataset[group] || '').split(' ').filter(Boolean);
  const labelOf = (input) => input.closest('.filter-option').querySelector('.filter-option__label').textContent;
  const selection = () => Object.fromEntries(groups.map((g) => [g, inputs.filter((i) => i.name === g && i.checked).map((i) => i.value)]));

  // Dentro de un grupo se suma (O); entre grupos se restringe (Y)
  const matches = (card, sel, skipGroup) =>
    groups.every((g) => g === skipGroup || !sel[g].length || sel[g].some((v) => valuesOf(card, g).includes(v)));

  function applyFilters() {
    if (interactive) grid.classList.add('is-animated');
    const sel = selection();
    let visible = 0;
    cards.forEach((card) => {
      const show = matches(card, sel);
      card.hidden = !show;
      if (show) visible += 1;
    });

    // Conteo de cada opción considerando lo elegido en los demás grupos
    inputs.forEach((input) => {
      const n = cards.filter((c) => matches(c, sel, input.name) && valuesOf(c, input.name).includes(input.value)).length;
      const option = input.closest('.filter-option');
      $('[data-count]', option).textContent = n;
      const off = n === 0 && !input.checked;
      input.disabled = off;
      option.classList.toggle('is-disabled', off);
    });

    const active = inputs.filter((i) => i.checked);
    countEl.textContent = plural(visible);
    applyBtn.textContent = visible ? `Ver ${plural(visible)}` : 'Sin resultados';
    badge.textContent = active.length;
    badge.hidden = !active.length;
    emptyEl.hidden = visible > 0;
    renderChips(active);
    syncUrl();
  }

  function renderChips(active) {
    chipsEl.hidden = !active.length;
    chipsEl.innerHTML = active.map((i) =>
      `<button type="button" class="plp-chip" data-remove-filter="${esc(i.name)}|${esc(i.value)}">${esc(labelOf(i))}<svg aria-hidden="true"><use href="#i-close"/></svg><span class="visually-hidden">(quitar filtro)</span></button>`
    ).join('') + (active.length > 1 ? '<button type="button" class="plp-chips__clear" data-clear-filters>Limpiar todo</button>' : '');
  }

  chipsEl.addEventListener('click', (e) => {
    const chip = e.target.closest('[data-remove-filter]');
    if (!chip) return;
    const [name, value] = chip.dataset.removeFilter.split('|');
    const input = inputs.find((i) => i.name === name && i.value === value);
    if (input) input.checked = false;
    applyFilters();
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-clear-filters]')) return;
    inputs.forEach((i) => { i.checked = false; });
    applyFilters();
  });

  form.addEventListener('change', applyFilters);

  /* ---------- Orden ---------- */
  const SORTERS = {
    featured: (a, b) => a.dataset.index - b.dataset.index,
    'price-asc': (a, b) => a.dataset.price - b.dataset.price || a.dataset.index - b.dataset.index,
    'price-desc': (a, b) => b.dataset.price - a.dataset.price || a.dataset.index - b.dataset.index,
    name: (a, b) => a.dataset.name.localeCompare(b.dataset.name, 'es'),
  };

  function sortCards() {
    if (interactive) grid.classList.add('is-animated');
    [...cards].sort(SORTERS[sortSelect.value] || SORTERS.featured).forEach((card) => grid.appendChild(card));
    syncUrl();
  }
  sortSelect.addEventListener('change', sortCards);

  /* ---------- Filtros y orden en la URL (para compartir o volver) ---------- */
  function syncUrl() {
    const params = new URLSearchParams();
    inputs.filter((i) => i.checked).forEach((i) => params.append(i.name, i.value));
    if (sortSelect.value !== 'featured') params.set('orden', sortSelect.value);
    const qs = params.toString();
    try { history.replaceState(null, '', qs ? `?${qs}` : location.pathname); } catch (e) { /* file:// */ }
  }

  function readUrl() {
    const params = new URLSearchParams(location.search);
    inputs.forEach((i) => { i.checked = params.getAll(i.name).includes(i.value); });
    const orden = params.get('orden');
    if (orden && SORTERS[orden]) sortSelect.value = orden;
  }

  /* ---------- Fotos de cada tarjeta: carrusel nativo (scroll-snap) ----------
     No cambian solas al pasar el mouse. Se desliza con el dedo (nativo) o con las flechas; los puntos siguen al scroll.
     La 2.ª foto es la de ambiente (o la segunda del producto) y se carga recién cuando hace falta. */
  const load = (img) => {
    if (!img || !img.dataset.src) return;
    img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;
    delete img.dataset.src;
  };
  const chevron = (dir) => `<svg viewBox="0 0 12 34" aria-hidden="true"><path vector-effect="non-scaling-stroke" d="${dir === 'left' ? 'M10.5 1.5 1.5 17l9 15.5' : 'M1.5 1.5 10.5 17l-9 15.5'}"/></svg>`;

  cards.forEach((card) => {
    const track = $('.plp-card__track', card);
    const slides = $$('.plp-card__img', track);
    if (slides.length < 2) return;
    const nav = document.createElement('div');
    nav.className = 'plp-card__nav';
    nav.innerHTML = `
      <button type="button" class="plp-card__arrow plp-card__arrow--prev" aria-label="Foto anterior" data-step="-1">${chevron('left')}</button>
      <button type="button" class="plp-card__arrow plp-card__arrow--next" aria-label="Foto siguiente" data-step="1">${chevron('right')}</button>
      <div class="plp-card__dots" aria-hidden="true">${slides.map((_, i) => `<span class="plp-card__dot${i ? '' : ' is-current'}"></span>`).join('')}</div>`;
    card.append(nav); // fuera del enlace: las flechas no abren el producto
    const dots = $$('.plp-card__dot', nav);
    const preload = () => slides.forEach(load);
    card.addEventListener('pointerenter', preload, { once: true }); // escritorio: al acercarse
    track.addEventListener('touchstart', preload, { once: true, passive: true }); // celular: al empezar a deslizar
    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach((d, k) => d.classList.toggle('is-current', k === i));
        ticking = false;
      });
    }, { passive: true });
  });

  const go = (track, i, smooth = true) => {
    const n = $$('.plp-card__img', track).length;
    const next = (i + n) % n; // de la última vuelve a la primera
    load($$('.plp-card__img', track)[next]);
    track.scrollTo({ left: next * track.clientWidth, behavior: smooth ? 'smooth' : 'instant' });
  };

  grid.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-step]');
    if (!btn) return;
    const track = $('.plp-card__track', btn.closest('.plp-card'));
    go(track, Math.round(track.scrollLeft / track.clientWidth) + +btn.dataset.step);
  });

  /* ---------- Barra de filtros fija ----------
     Se pega bajo el header; al quedar fija se compacta (.is-stuck) y el header le cede la sombra. */
  const bar = $('[data-plp-bar]');
  const siteHeader = $('[data-header]');
  if (bar && siteHeader) {
    // Fija = su borde de arriba ya llegó al borde de abajo del header (medido en vivo: no depende del ancho)
    const onBar = () => {
      const stuck = window.scrollY > 0 && bar.getBoundingClientRect().top <= siteHeader.getBoundingClientRect().bottom + 1;
      bar.classList.toggle('is-stuck', stuck);
    };
    document.documentElement.classList.add('has-plp-bar'); // el header deja la sombra a la barra
    onBar();
    window.addEventListener('scroll', onBar, { passive: true });
    window.addEventListener('resize', onBar);
  }

  /* ---------- Producto o en escena: elige la foto que se ve primero en todas las tarjetas ----------
     En el celular, las tarjetas a la vista se deslizan juntas, con el mismo ritmo exacto: una sola animación
     compartida (el scroll suave nativo de cada carrusel va a su propio paso y se desfasaban). En desktop, con muchas
     tarjetas a la vista, el cambio es inmediato (deslizarlas todas se sentía pesado). Las de fuera de pantalla
     cambian siempre al instante. */
  const photoBtns = $$('[data-photo]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const touchLayout = window.matchMedia('(max-width: 959px)');
  const glide = (items) => {
    if (!items.length) return;
    const start = performance.now();
    const duration = 560;
    const ease = (t) => 1 - (1 - t) ** 3;
    items.forEach((it) => { it.from = it.track.scrollLeft; it.track.style.scrollSnapType = 'none'; });
    const step = (now) => {
      const t = Math.min(1, (now - start) / duration);
      items.forEach((it) => { it.track.scrollLeft = it.from + (it.to - it.from) * ease(t); });
      if (t < 1) requestAnimationFrame(step);
      else items.forEach((it) => { it.track.style.scrollSnapType = ''; });
    };
    requestAnimationFrame(step);
  };
  function setPhoto(mode, animate = false) {
    photoBtns.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.photo === mode)));
    const moving = [];
    cards.forEach((card) => {
      const hasScene = !!$('.plp-card__img--scene', card);
      if (!hasScene && mode === 'escena') return;
      const track = $('.plp-card__track', card);
      const target = mode === 'escena' ? 1 : 0;
      const r = card.getBoundingClientRect();
      if (animate && touchLayout.matches && !reduceMotion.matches && !card.hidden && r.bottom > 0 && r.top < innerHeight) {
        load($$('.plp-card__img', track)[target]);
        moving.push({ track, to: target * track.clientWidth });
      } else {
        go(track, target, false);
      }
    });
    glide(moving);
    remember('plp-photo', mode);
  }
  photoBtns.forEach((b) => b.addEventListener('click', () => {
    if (b.getAttribute('aria-pressed') === 'true') return;
    setPhoto(b.dataset.photo, true);
    if (navigator.vibrate) navigator.vibrate(8); // un toque háptico breve en Android
  }));

  // Celular: el visor flota abajo solo mientras la grilla está en pantalla (no tapa la portada ni el pie).
  // La primera vez que aparece, la otra opción late.
  const photoSwitch = $('.plp-photo');
  if (photoSwitch && 'IntersectionObserver' in window) { // sin fotos en escena en la colección no hay visor
    let hinted = false;
    new IntersectionObserver(([entry]) => {
      photoSwitch.classList.toggle('is-shown', entry.isIntersecting);
      if (entry.isIntersecting && !hinted) {
        hinted = true;
        photoSwitch.classList.add('is-hinting');
        setTimeout(() => photoSwitch.classList.remove('is-hinting'), 4200);
      }
    }, { rootMargin: '0px 0px -30% 0px' }).observe(grid);
  }

  /* ---------- Tamaño de la grilla ---------- */
  // Escritorio: grande 3, mediana 4, pequeña 5 por fila (tablet 2/3/4). Celular: grande 1, mediana 2 (la pequeña no aplica).
  const densityBtns = $$('[data-density]', $('.plp-density'));
  const mobile = window.matchMedia('(max-width: 699px)');
  const SIZES = {
    l: '(min-width: 1101px) 33vw, (min-width: 700px) 50vw, 100vw',
    m: '(min-width: 1101px) 25vw, (min-width: 700px) 33vw, 50vw',
    s: '(min-width: 1101px) 20vw, (min-width: 700px) 25vw, 50vw',
  };
  let density = recall('plp-density') || 'm';
  function setDensity(d) {
    density = d;
    const shown = mobile.matches && d === 's' ? 'm' : d;
    grid.dataset.density = d;
    densityBtns.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.density === shown)));
    $$('img', grid).forEach((img) => { img.sizes = SIZES[shown]; }); // fotos más grandes piden más resolución
    remember('plp-density', d);
  }
  densityBtns.forEach((b) => b.addEventListener('click', () => {
    if (interactive) grid.classList.add('is-animated');
    setDensity(b.dataset.density);
  }));
  mobile.addEventListener('change', () => setDensity(density));

  // Preferencias de vista por visitante (si el navegador no deja guardar, se usa la vista por defecto)
  function remember(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* sin almacenamiento */ } }
  function recall(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

  /* ---------- Preguntas frecuentes: cada H2 del texto SEO (metacampo) abre su respuesta ----------
     El texto queda completo en el HTML (SEO); en el navegador se arma el acordeón del diseño. */
  const seo = $('[data-seo-accordion]');
  if (seo) {
    let item = null;
    const seoRoot = seo.querySelector(':scope > .metafield-rich_text_field') || seo;   // metafield_tag envuelve el texto
    [...seoRoot.children].forEach((el) => {
      if (el.tagName === 'H2') {
        item = document.createElement('details');
        item.className = 'plp-seo__item';
        const summary = document.createElement('summary');
        summary.append(el.cloneNode(true));
        summary.insertAdjacentHTML('beforeend', '<span class="m-acc__icon" aria-hidden="true"></span>');
        item.append(summary);
        el.replaceWith(item);
      } else if (item) {
        item.append(el);
      }
    });
  }

  /* ---------- Inicio ---------- */
  setDensity(density);
  if (recall('plp-photo') === 'escena' && !mobile.matches) setPhoto('escena'); // en el celular no hay visor: siempre producto
  readUrl();
  if (sortSelect.value !== 'featured') sortCards();
  applyFilters();
  interactive = true;
  hintCarousel();

  /* ---------- Pista: la 1.ª tarjeta asoma su otra foto una vez, para que se note que se puede deslizar ----------
     Solo una vez por visita, si la tarjeta está a la vista, la otra foto ya cargó y nadie tocó nada todavía. */
  function hintCarousel() {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    try { if (sessionStorage.getItem('plp-hint')) return; } catch (e) { /* sin almacenamiento: se muestra igual */ }
    const card = cards.find((c) => !c.hidden && $$('.plp-card__img', c).length > 1);
    if (!card || !('IntersectionObserver' in window)) return;
    const track = $('.plp-card__track', card);
    const slides = $$('.plp-card__img', track);
    let touched = false;
    const stop = () => { touched = true; };
    ['pointerdown', 'wheel', 'keydown'].forEach((t) => window.addEventListener(t, stop, { once: true, passive: true }));
    const io = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      io.disconnect();
      const other = slides[Math.round(track.scrollLeft / track.clientWidth) ? 0 : 1];
      load(other);
      const play = () => setTimeout(() => {
        if (touched) return;
        const dir = Math.round(track.scrollLeft / track.clientWidth) ? 1 : -1; // hacia la foto que no se ve
        const frames = [
          { transform: 'translateX(0)' },
          { transform: `translateX(${dir * 18}%)`, offset: 0.4 },
          { transform: `translateX(${dir * 18}%)`, offset: 0.6 },
          { transform: 'translateX(0)' },
        ];
        slides.forEach((img) => img.animate(frames, { duration: 1400, easing: 'cubic-bezier(.2, .7, .2, 1)' }));
        try { sessionStorage.setItem('plp-hint', '1'); } catch (e) { /* nada */ }
      }, 700);
      if (other.complete && other.naturalWidth) play();
      else other.addEventListener('load', play, { once: true });
    }, { threshold: 0.7 });
    io.observe(track);
  }
})();
